<template>
    <div class="Banner">
        <swiper class="swiper" :options="swiperOption">
            <!-- <swiper-slide>
                <img src="../../assets/百姓巡常行主k1.8.png" alt="">
            </swiper-slide> -->
            <swiper-slide v-for="item in Data" :key="item.id">
                <img :src="item.url" alt="">
            </swiper-slide>
            <div v-if="Data.length>1" class="swiper-pagination" slot="pagination"></div>
        </swiper>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                Data: [],
                swiperOption: {
                    loop: true,
                    autoplay: {
                        delay: 3000,
                        stopOnLastSlide: false,
                        disableOnInteraction: false
                    },
                    // 显示分页
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true 
                    },
                }
            }
        },
        mounted() {
            this.GetData()
        },
        methods: {
            GetData() {
                // PC端和移动端都使用静态数据
                this.$get("#").then(res => {
                    if(res.data.code == 1){
                        this.Data = res.data.data;
                    } else {
                        // 加载失败时使用静态数据
                        this.Data = [
                        // { id: 1, url: require('../../assets/微信图片_20250530134231.jpg') },
                            { id: 2, url: require('../../assets/百姓巡常行主k1.8.png') }
                        ];
                    }
                }).catch(() => {
                    // 请求出错时使用静态数据
                    this.Data = [
                    // { id: 1, url: require('../../assets/微信图片_20250530134231.jpg') },
                    { id: 2, url: require('../../assets/百姓巡常行主k1.8.png') }
                    ];
                })
            },
            //PC端使用的跳转功能
            GoPage(url) {
                this.$router.push({
                    path: url
                });
            },
        },
    }
</script>
<style scoped>
    .swiper-pagination-bullet {  
      width: 8px;              /* 自定义宽度 */  
      height: 5px;             /* 自定义高度 */  
      background-color: #fff;   /* 自定义背景颜色 */  
      opacity: 1;               /* 自定义透明度 */  
      border-radius: 3px;       /* 自定义圆角 */  
    }  
    .swiper-pagination-bullet-active {  
        width: 15px;    
        background-color: #ea670c; /* 自定义激活状态的背景颜色 */  
    }
</style>
<style scoped>
    /* PC端样式 */
    .Banner {
        max-height: 500px;
        width: 100%;
        padding: 0;
        margin: 0 auto;
        margin-top: 0; /* 确保banner顶部没有边距 */
    }
    .Banner img {
        width: 100%;
        max-height: 500px;
        border-radius: 0;
        display: block; /* 移除图片底部的空隙 */
    }
    
    /* 移动端样式 - 只在小屏幕设备上应用 */
    @media only screen and (max-width: 768px) {
        .Banner {
            height: auto;
            max-height: none;
        }
        .Banner img {
            min-height: auto;
            max-height: none;
            height: auto;
            width: 100%;
            object-fit: contain;
        }
    }
</style>